module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }